module.exports = __webpack_public_path__ + "mk.c62e5818.svg";